import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

// Super-admin: every community's allowance usage + overage for a month (from /admin/usage/overage).
export function OverageTable({ month }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get(`/admin/usage/overage${month ? `?month=${month}` : ""}`).then((r) => { if (alive) setData(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, [month]);
  if (!data) return null;
  const cell = (l) => l ? (
    <span className={l.pct != null && l.pct >= 100 ? "text-redline-600 font-semibold" : l.pct != null && l.pct >= 80 ? "text-amber-700" : "text-ink/70"}>
      {Number(l.used).toLocaleString(undefined, { maximumFractionDigits: 1 })}{l.allowance == null ? " · ∞" : ` / ${Number(l.allowance).toLocaleString()}`}
    </span>
  ) : "—";
  return (
    <div className="bg-white rounded-2xl border border-sand-200 overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)]" data-testid="overage-table">
      <div className="px-5 py-4 border-b border-sand-200 flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="font-heading font-bold text-lg">Allowances &amp; overage by community</h2>
        <span className="text-xs text-ink/50">{data.month} · used / included · overage is what the association owes</span>
      </div>
      {data.communities.length === 0 ? <div className="px-5 py-10 text-center text-ink/40">No metered usage this month.</div> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[720px]">
            <thead><tr className="text-ink/40 text-[10px] uppercase tracking-wide">
              <th className="text-left font-semibold px-5 py-2">Community</th>
              <th className="text-right font-semibold py-2">Texts</th>
              <th className="text-right font-semibold py-2">Voice min</th>
              <th className="text-right font-semibold py-2">Copilot</th>
              <th className="text-right font-semibold py-2">Onboarding</th>
              <th className="text-right font-semibold py-2">Our cost</th>
              <th className="text-right font-semibold py-2 pr-5">Overage</th>
            </tr></thead>
            <tbody>
              {data.communities.map((c) => (
                <tr key={c.tenant_id} data-testid={`overage-row-${c.tenant_id}`} className="border-t border-sand-100">
                  <td className="px-5 py-2.5 font-medium text-ink">
                    <Link to={`/dashboard/settings?tab=usage&tenant=${c.tenant_id}`} className="hover:underline">{c.name}</Link>
                    <span className="text-ink/40 text-xs"> · {c.doors} doors</span>
                    {c.paused && <span className="ml-2 rounded-full bg-amber-100 text-amber-800 px-1.5 py-0.5 text-[9px] font-bold uppercase">Paused</span>}
                  </td>
                  <td className="py-2.5 text-right tabular-nums">{cell(c.lines.texts)}</td>
                  <td className="py-2.5 text-right tabular-nums">{cell(c.lines.voice)}</td>
                  <td className="py-2.5 text-right tabular-nums">{cell(c.lines.copilot)}</td>
                  <td className="py-2.5 text-right tabular-nums">{cell(c.lines.onboarding)}</td>
                  <td className="py-2.5 text-right tabular-nums text-ink/60">{money(c.cost)}</td>
                  <td className={`py-2.5 text-right pr-5 font-bold tabular-nums ${c.total_overage_usd > 0 ? "text-emerald-600" : "text-ink/40"}`}>{money(c.total_overage_usd)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
